import { Box, Stack } from '@mui/material';
import { useIsDesktop } from 'Hooks';

interface IChatBubble {
  isRtl: boolean;
  children: React.ReactNode;
  maxWidth?: string;
  minWidth?: string;
  backgroundColor?: string;
  borderColor?: string;
}

export const ChatBubble = ({
  isRtl,
  children,
  maxWidth,
  minWidth,
  backgroundColor,
  borderColor,
}: IChatBubble) => {
  const isDesktop = useIsDesktop();

  const margin = isDesktop
    ? '0 32px'
    : isRtl
    ? '0 47px 0 22px'
    : '0 22px 0 47px';

  return (
    <Stack margin={margin} width={'auto'}>
      <Box
        sx={{
          display: 'inline-block',
          position: 'relative',
          maxWidth: maxWidth || '530px',
          height: 'auto',
          backgroundColor: backgroundColor
            ? backgroundColor
            : isRtl
            ? 'primary.shade_100'
            : 'primary.shade_50',
          border: '1px  solid',
          borderColor: borderColor ?? 'primary.shade_200',
          borderRadius: '6px',
          borderTopRightRadius: '0px',

          '&::before': {
            content: '" "',
            position: 'absolute',
            width: 0,
            height: 0,
            left: 'auto',
            right: '-8px',
            top: '-0.5px',
            bottom: 'auto',
            border: '8px solid',
            borderColor: `${
              borderColor ? borderColor : '#B7CCFF'
            } transparent transparent transparent`,
          },

          '&::after': {
            content: '" "',
            position: 'absolute',
            width: 0,
            height: 0,
            left: 'auto',
            right: '-6px',
            top: '0px',
            bottom: 'auto',
            border: '8px solid',
            borderColor: `${
              backgroundColor ? backgroundColor : isRtl ? '#E7EDFF' : '#F6F8FE'
            } transparent transparent transparent`,
          },

          transform: isRtl ? 'scaleX(-1)' : undefined,
          ml: isRtl ? undefined : 'auto',
        }}
      >
        <Stack sx={{ transform: isRtl ? 'scaleX(-1)' : undefined }}>
          {children}
        </Stack>
      </Box>
    </Stack>
  );
};
